import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { Box } from '@mui/material'
import {
  CartesianGrid,
  Line,
  LineChart,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

import { useGET_dashboardGradebookAssessmentsQuery } from 'redux/api/dashboardApi'
import { RootState } from 'redux/store'
import BoxTitle from 'components/atoms/BoxTitle'
import { Grading } from '@mui/icons-material'

const Grades = ({student=null, subject}) => {
  const { t } = useTranslation()
  const reduxKey = 'dashboard'

  const filters = {
    due_date_after: useSelector((state: RootState) => state[reduxKey].date_after),
    due_date_before: useSelector((state: RootState) => state[reduxKey].date_before),
    subject: subject.id
  }
  if(student)
    filters["student"]=student

  const { data } = useGET_dashboardGradebookAssessmentsQuery(filters)

  return (
    <Box className="thick-border" sx={{ height: '350px' }}> { data && <>
      <BoxTitle title={subject.title} icon={<Grading />} />
      <div style={{ height: '20px' }} />
      <ResponsiveContainer width='100%' height='90%'>
        <LineChart
          data={data.slice(-6)}
          margin={{
            bottom: 20,
            right: 20
          }}
        >
          <XAxis dataKey='month' padding={{ left: 20 }} interval={0} tick={<CustomizedAxisTick />} />
          <YAxis />
          <Tooltip />
          <ReferenceLine y={100} />
          <Line
            type='monotone'
            dataKey='avg_grade_percentage'
            stroke={subject.color_hex_code || '#333333'}
            strokeWidth={2}
            activeDot={{ r: 2 }}
            label={<CustomizedLabel />}
          />
        </LineChart>
      </ResponsiveContainer> </>}
    </Box>
  )
}

export default Grades

export const CustomizedLabel = (props) => {
  const { x, y, stroke, value } = props
  return (
    <text x={x} y={y} dy={-4} fill={stroke} fontSize={10} textAnchor='middle'>
      {`${value} %`}
    </text>
  )
}
export const CustomizedAxisTick = (props) => {
  const { x, y, payload } = props

  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={16} fontSize={10} textAnchor='end' fill='#666' transform='rotate(-35)'>
        {payload.value}
      </text>
    </g>
  )
}
